"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* global gapi */
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var attach_script_1 = tslib_1.__importDefault(require("../../../../../common/utils/attach-script"));
var accessible_social_button_1 = tslib_1.__importDefault(require("./accessible-social-button"));
var LIBRARY_URL = 'https://apis.google.com/js/platform.js';
var YoutubeButton = /** @class */ (function (_super) {
    tslib_1.__extends(YoutubeButton, _super);
    function YoutubeButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.init = function (containerNode) {
            gapi.ytsubscribe.render(containerNode, {
                channelid: _this.props.cardData.id,
                count: 'hidden',
            });
            return new Promise(function (resolve) {
                setTimeout(resolve);
            });
        };
        return _this;
    }
    YoutubeButton.prototype.attachScript = function () {
        if (window.gapi) {
            return Promise.resolve();
        }
        return (0, attach_script_1.default)(LIBRARY_URL);
    };
    YoutubeButton.prototype.render = function () {
        var _a = this.props, isAccessible = _a.isAccessible, youtubeButtonTitle = _a.youtubeButtonTitle;
        return (react_1.default.createElement(accessible_social_button_1.default, { isAccessible: isAccessible, attachScript: this.attachScript, title: youtubeButtonTitle, initButton: this.init }));
    };
    YoutubeButton.propTypes = {
        cardData: prop_types_1.default.object,
        isAccessible: prop_types_1.default.bool,
        youtubeButtonTitle: prop_types_1.default.string,
    };
    return YoutubeButton;
}(react_1.default.Component));
exports.default = YoutubeButton;
//# sourceMappingURL=youtube.js.map